import React from 'react';
import './SkanetrafikenRoutes.scss';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import PriceItem from 'Components/Shared/PriceItem/PriceItem';
import { Icon } from 'antd';

interface IProps {
  type: 'route-availability' | 'route-reservations';
  isMobile: boolean;
  isSelectable: boolean;
  travelDirection: 0 | 1;
  travelRoutes: Julius.Website.TravelRouteViewModel[];
  onSelect: (travel: Julius.Website.TravelRouteViewModel) => void;
}

const SkanetrafikenRoutes: React.SFC<IProps> = ({
  isMobile,
  type,
  travelDirection,
  isSelectable,
  travelRoutes,
  onSelect,
}) => {

  const Title = () => (
    type === 'route-reservations' ?
      <FormattedText 
        style='title black'
        displayName='Dina reserverade resor'
        formattedName=''
      /> :
    type === 'route-availability' && travelDirection === 0 ?
      <FormattedText 
        style='title black'
        displayName='Avresa'
        formattedName=''
      /> :
    type === 'route-availability' && travelDirection === 1 ?
      <FormattedText 
        style='title black'
        displayName='Hemresa'
        formattedName=''
      /> :
    null
  );

  if (!travelRoutes || !travelRoutes.length) {
    return (
      <div className='skanetrafiken-routes'>
        <Title />
        <FormattedText 
          displayName='Kunde inte hitta några resor.'
          formattedName=''
        /> 
      </div>
    );
  }

  if (isMobile) {
    return (
      <div className='skanetrafiken-routes'>
        <Title />
        <div className='route-list-mobile'>
          { travelRoutes.map((t, i) => 
            <div className='route-item' key={ `${ i }-${ t.travelID }` }>
              <div className='description'>
                { t.name }. { t.priceType }&nbsp;
                <PriceItem 
                  price={ t.price } 
                  decimals={ 2 } 
                />
              </div>
              { isSelectable &&
                <Icon 
                  type={ type === 'route-availability' ? 'plus' : 'minus' }
                  onClick={ () => onSelect(t) } 
                />
              }
            </div>)
          }
        </div>
      </div>
    )
  }

  return (
    <div className='skanetrafiken-routes'>
      <Title />
      <table className='route-list'>
        <tbody>
          { travelRoutes.map((t, i) => 
            <tr key={ `${ i }-${ t.travelID }` }>
              <td>{ t.name }</td>
              <td>{ t.priceType }</td>
              <td>
                <PriceItem 
                  price={ t.price } 
                  decimals={ 2 } 
                />
              </td>
              <td>
                { isSelectable &&
                  <Icon 
                    type={ type === 'route-availability' ? 'plus' : 'minus' }
                    onClick={ () => onSelect(t) } 
                  />
                }
              </td>
            </tr>)
          }
        </tbody>
      </table>
    </div>
  )

}

export default SkanetrafikenRoutes;


// WEBPACK FOOTER //
// ./src/components/PickSkanetrafiken/SkanetrafikenRoutes/SkanetrafikenRoutes.tsx